import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";

export default function Detail() {
    const [content, setContent] = useState();

    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [visible, setVisible] = useState(true);
    const [links, setLinks] = useState([]);

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const id = queryParams.get("id");

    const requestData = () => {
        if (id !== null && id !== "") {
            axios.get(`/admin/knowledge-s/${id}`)
                .then((res) => {
                    setContent(res.data);
                    setTitle(res.data.title);
                    setSubTitle(res.data.subTitle);
                    setVisible(res.data.visible);
                    setLinks(res.data.links);
                });
        }
    }

    const requestSave = () => {
        const params = {}
        params.title = title;
        params.subTitle = subTitle;
        params.visible = visible;
        params.links = links;

        if (id === null || id === "") {
            axios.post(`/admin/knowledge-s`, JSON.stringify(params))
                .then((res) => {
                    alert('생성 되었습니다.');
                    navigate(-1);
                });
        } else {
            params.id = id;
            axios.put(`/admin/knowledge-s`, JSON.stringify(params))
                .then((res) => {
                    alert('수정 되었습니다.');
                    navigate(-1);
                });
        }
    }

    const createLinkRow = () => {
        const link = {}
        link.title = ''
        link.link = ''
        setLinks([...links, link])
    }

    const removeLinkRow = (index) => {
        const removedLinks = links.filter((link, offset) =>  offset !== index )
        setLinks(removedLinks)
    }

    const writeLinkTitle = (index, e) => {
        let newLinks = [...links];
        newLinks[index].title = e.target.value;
        setLinks(newLinks);
    }

    const writeLink = (index, e) => {
        let newLinks = [...links];
        newLinks[index].link = e.target.value;
        setLinks(newLinks);
    }

    useEffect(() => {
        requestData()
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">메인화면-노무지식-상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-body">
                                        <div className="row">
                                            <label htmlFor="input-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>제목</label>
                                            <div className="col-sm-10">
                                                <input id="input-title"
                                                       type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setTitle(event.target.value);
                                                       }}
                                                       value={title}
                                                />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label htmlFor="input-sub-title"
                                                   className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>부제목</label>
                                            <div className="col-sm-10">
                                                <input id="input-sub-title"
                                                       type="text"
                                                       className="form-control"
                                                       onChange={event => {
                                                           setSubTitle(event.target.value);
                                                       }}
                                                       value={subTitle} />
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: "10px"}}>
                                            <label className="col-form-label col-sm-1"
                                                   style={{marginLeft: "8px"}}>노출여부</label>
                                            <div className="col-sm-10">
                                                <select id="input-visible"
                                                        className="form-control"
                                                        style={{width: '200px', marginRight: '10px'}}
                                                        onChange={event => {
                                                            setVisible(event.target.value);
                                                        }}
                                                        value={visible}>
                                                    <option value="true">노출</option>
                                                    <option value="false">미노출</option>
                                                </select>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="card card-secondary col-sm-12">
                                    <div className="card-header">
                                        <h3 className="card-title">링크</h3>
                                        <button type="button"
                                                className="btn btn-light btn-xs"
                                                style={{width: "70px", height: "30px", marginTop: "-5px", float: "right"}}
                                                onClick={createLinkRow}>추 가
                                        </button>
                                    </div>

                                    <div className="card-body" id="comment-body">
                                        {
                                            links.map((link, index) => {
                                                return (
                                                    <div className="row" style={{marginBottom: '30px'}}>
                                                        <div className="col-sm-10 row">
                                                            <label htmlFor={`input-link-title-${index}`}
                                                                   className="col-form-label col-sm-1"
                                                                   style={{marginLeft: "8px"}}>제목</label>
                                                            <div className="col-sm-10">
                                                                <input id={`input-link-title-${index}`}
                                                                       type="text"
                                                                       className="form-control"
                                                                       onChange={event => writeLinkTitle(index, event)}
                                                                       value={link.title}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-10 row">
                                                            <label htmlFor={`input-link-${index}`}
                                                                   className="col-form-label col-sm-1"
                                                                   style={{marginLeft: "8px"}}>링크</label>
                                                            <div className="col-sm-10">
                                                                <input id={`input-link-${index}`}
                                                                       type="text"
                                                                       className="form-control"
                                                                       onChange={event => writeLink(index, event)}
                                                                       value={link.link}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-1 row">
                                                            <button type="button" className="btn btn-block btn-danger btn-xs"
                                                                    style={{width: "50px", float: "right"}}
                                                                    onClick={() => removeLinkRow(index)}>삭 제
                                                            </button>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>


                    <div className="row">
                        <div style={{margin: "0 auto"}}>
                            <button type="button" className="btn btn-outline-secondary"
                                    onClick={event => {navigate(-1)}}>
                                목록
                            </button>
                            <button type="button" className="btn btn-outline-primary"
                                    style={{marginLeft: "10px"}}
                                    onClick={requestSave}
                            >
                                {id === null ? '저장' : '수정'}
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}